import {
  Text,
  Modal,
  Button,
  Heading,
  useToast,
  ModalBody,
  ButtonGroup,
  ModalFooter,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton
} from '@homebotapp/hb-react-component-catalog'
import { REA } from '../../../constants/agent_types'
import { RootState } from '../../../types/rootState'
import { useIntl, defineMessages } from 'react-intl'
import { useAppSelector } from '../../../store/hooks'
import { useDispatch, useSelector } from 'react-redux'
import { useTrackingContext } from '../../../providers/tracking'
import { sendPrequalRequestForClient } from '../../../actions/affordability'
import { selectSponsorshipFirstName } from '../../../store/selectors/sponsorship'
import history from '../../../history'

export const MSG = defineMessages({
  title: {
    id: 'PrequalConfirmationModal.title',
    defaultMessage: 'Want to get pre-qualified?'
  },
  body: {
    id: 'PrequalConfirmationModal.body',
    defaultMessage:
      'Pre-qualifying with {lo} gives you a clear budget with no obligation to move forward, so you are ready to act when you find the right home.'
  },
  cancel: {
    id: 'PrequalConfirmationModal.cancel',
    defaultMessage: 'Cancel'
  },
  send: {
    id: 'PrequalConfirmationModal.confirm',
    defaultMessage: 'Confirm'
  },
  prequalRequestSuccess: {
    id: 'PrequalConfirmationModal.prequalRequestSuccess',
    defaultMessage: 'Pre-qualification request sent!'
  }
})

export interface PrequalConfirmationModalProps {
  uiContext: string
  onClose: () => void
}

export const PrequalConfirmationModal = ({ uiContext, onClose }: PrequalConfirmationModalProps) => {
  const intl = useIntl()
  const toast = useToast()
  const dispatch = useDispatch()
  const { trackingClient } = useTrackingContext()
  const sponsorName = useSelector(selectSponsorshipFirstName)
  const isRea = useAppSelector((state: RootState) => state.customerProfile?.data?.type === REA)
  const customerName = useAppSelector((state: RootState) => state.customerProfile?.data?.firstName)

  const handleClose = () => {
    const url = new URL(location.href)

    if (url.searchParams.has('openPrequalModal')) {
      url.searchParams.delete('openPrequalModal')
      history.push(url.pathname + url.search)
    }

    onClose()
  }

  const handleClick = () => {
    dispatch(sendPrequalRequestForClient(trackingClient, { uiContext }))

    toast({
      status: 'success',
      title: intl.formatMessage(MSG.prequalRequestSuccess)
    })

    handleClose()
  }

  return (
    <Modal isOpen={true} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading mb={0} textAlign='left'>
            {intl.formatMessage(MSG.title)}
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text as='span'>
            {intl.formatMessage(MSG.body, {
              lo: isRea ? sponsorName : customerName
            })}
          </Text>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup spacing={3}>
            <Button
              size='sm'
              tracking={{
                descriptor: 'Cancel',
                guid: 'h3mNiEcQNCjg4D7PzVq429',
                ui_context: 'PrequalConfirmationModal'
              }}
              onClick={handleClose}
            >
              {intl.formatMessage(MSG.cancel)}
            </Button>
            <Button
              size='sm'
              variant='solid'
              colorScheme='primary'
              onClick={handleClick}
              tracking={{
                descriptor: 'Confirm',
                guid: 'qzAfyt6NzijMnEcCbPvhpH',
                ui_context: 'PrequalConfirmationModal'
              }}
            >
              {intl.formatMessage(MSG.send)}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
